import { defaultFill } from './utils/constants';
var muiCheckCircleFillBase = {
    paths: [
        {
            path: 'M6.88,9.44 L5.16,7.72 C5.013336,7.57336 4.826664,7.5 4.6,7.5 C4.373336,7.5 4.186664,7.57336 4.04,7.72 C3.893336,7.86664 3.82,8.05336 3.82,8.28 C3.82,8.50664 3.893336,8.69336 4.04,8.84 L6.32,11.12 C6.48,11.28 6.66664,11.36 6.88,11.36 C7.09336,11.36 7.28,11.28 7.44,11.12 L11.96,6.6 C12.10664,6.45336 12.18,6.266664 12.18,6.04 C12.18,5.813336 12.10664,5.626664 11.96,5.48 C11.81336,5.333336 11.62664,5.26 11.4,5.26 C11.17336,5.26 10.98664,5.333336 10.84,5.48 L6.88,9.44 Z M8,16 C6.89336,16 5.853336,15.79 4.88,15.37 C3.906664,14.95 3.06,14.38 2.34,13.66 C1.62,12.94 1.05,12.09336 0.63,11.12 C0.21,10.14664 0,9.10664 0,8 C0,6.89336 0.21,5.853336 0.63,4.88 C1.05,3.906664 1.62,3.06 2.34,2.34 C3.06,1.62 3.906664,1.05 4.88,0.63 C5.853336,0.21 6.89336,0 8,0 C9.10664,0 10.14664,0.21 11.12,0.63 C12.09336,1.05 12.94,1.62 13.66,2.34 C14.38,3.06 14.95,3.906664 15.37,4.88 C15.79,5.853336 16,6.89336 16,8 C16,9.10664 15.79,10.14664 15.37,11.12 C14.95,12.09336 14.38,12.94 13.66,13.66 C12.94,14.38 12.09336,14.95 11.12,15.37 C10.14664,15.79 9.10664,16 8,16 Z',
            fill: defaultFill,
        },
    ],
    title: 'check circle',
    width: 24,
    height: 24,
    rotate: 0,
    translate: [4, 4],
};
var muiCheckCircleFill = {
    base: muiCheckCircleFillBase,
};
export { muiCheckCircleFill };
//# sourceMappingURL=checkCircleFill.js.map